import React, { useState } from 'react';
import { i18n } from '../i18n/i18n';
import { authCardClass, authInputClass, authLabelClass, authScreenShellClass } from './authUiClasses';
import { requestPasswordReset } from '../services/apiService';

const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      await requestPasswordReset(email, i18n.language);
      setSent(true);
    } catch {
      // Always show success to prevent enumeration
      setSent(true);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={authScreenShellClass}>
      <div className={authCardClass}>
        <h2 className="text-center text-gray-800 dark:text-gray-100 mb-8 text-3xl font-semibold">{i18n.t('auth.forgot_title')}</h2>
        {sent ? (
          <div className="text-center text-gray-700 dark:text-gray-300">
            <p className="mb-4">{i18n.t('auth.forgot_confirmation')}</p>
          </div>
        ) : (
          <form onSubmit={submit}>
            <div className="mb-5">
              <label htmlFor="email" className={authLabelClass}>
                {i18n.t('auth.email_label')}:
              </label>
              <input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                disabled={isLoading}
                className={authInputClass}
              />
            </div>
            <button
              type="submit"
              disabled={isLoading}
              className="w-full h-12 py-0 flex items-center justify-center bg-btn-success text-btn-text-primary rounded-lg text-base font-semibold disabled:opacity-70"
            >
              {i18n.t('auth.send_reset_link')}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;



